import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function RecipeReviewCard({ cardDetails, text }) {
  return (
    <Box
      sx={{
        display: "grid",
        gridGap: "30px",
        gridTemplateColumns: {
          lg: "repeat(3, 1fr)",
          sm: "repeat(2, 1fr)",
          xs: "repeat(1, 1fr)",
        },
      }}
    >
      {cardDetails.map((card, index) => (
        <Card sx={{ maxWidth: 345 }} key={index}>
          <CardHeader title={card.cardName} />
          <Typography
            sx={{ padding: 2 }}
            variant="body2"
            color="text.secondary"
          >
            {card.cardDescription}
          </Typography>
          <CardMedia
            component="img"
            height="194"
            image={card.cardImage}
            alt="Project image"
          />
          <CardContent>
            <Typography variant="body2" color="text.secondary">
              {card.cardTech}
            </Typography>
          </CardContent>
          <CardActions disableSpacing>
            <a target="_blank" href={card.cardLink} rel="noreferrer">
              {text}
            </a>
            {card.cardRepo && (
              <a target="_blank" href={card.cardRepo} rel="noreferrer">
                GitHub Repo
              </a>
            )}
          </CardActions>
        </Card>
      ))}
    </Box>
  );
}

/*

<div className="resume-screen-container" key="projects">
        <p className="resume-header">Projects</p>
        <Card projectsDetails={projectsDetails} />
        <br />
        <br />
        <div className="line"></div>
      </div>

*/
